'use strict';

module.exports = {
    leftTop: 0,
    rightTop: 1,
    rightBottom: 2,
    leftBottom: 3,
    none: 4
};
